/** @format */

import { useState } from 'react';

export default function useExtranetContentActions() {
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);

  const handlePrint = () => {
    if (typeof window !== 'undefined' && typeof window.print === 'function') {
      window.print();
    }
  };

  const handleShareClick = () => {
    setIsShareModalOpen(true);
  };

  const handleShareModalClose = () => {
    setIsShareModalOpen(false);
  };

  const shareUrl = typeof window !== 'undefined' ? window.location.href : '';

  return {
    isShareModalOpen,
    shareUrl,
    handlePrint,
    handleShareClick,
    handleShareModalClose
  };
}
